<template>
  <div class="footer"
       :class="{'page1': $route.path === '/page/1', 'page3': $route.path === '/page/3'}">
    <div>
      <div class="item">Copyright © 2019 优托邦 版权所有 保留一切权利</div>
      <div class="item">
        <div @click="handleClick(['common/license_1.png'])">营业执照&nbsp;   </div>
        <div @click="getICP">粤ICP备17150681号&nbsp;   </div>
        <div @click="handleClick(['common/license_2.png', 'common/license_3.png'])">增值电信业务经营许可证：粤B2-20191477 &nbsp;   </div>
        <div @click="handleClick(['common/license_5.png'])">互联网药品信息服务资格证书：(粤)-经营性-2021-0469  &nbsp;</div>
        <div @click="handleClick(['common/license_8.png', 'common/license_9.png'])">出版物网络发行服务备案：粤新出备(2022)02号</div>
      </div>
      <div class="item" >
        <div @click="handleClick(['common/license_6.png'])">食品经营许可证：JY14401120188839（1-1）&nbsp;</div>
        <div @click="handleClick(['common/license_7.png'])">网络食品交易第三方平台备案凭证：粤B2-20191477 &nbsp;</div>
        <div @click="handleClick(['common/license_4.png'])">医疗器械网络交易服务第三方平台备案凭证：（粤）网络平台备字（2021）第00032号</div>
      </div>
    </div>
  </div>
  <!-- <div class="footer"
       :class="{'page1': $route.path === '/page/1', 'page3': $route.path === '/page/3'}">
    <p>Copyright © 2019 优托邦 版权所有 保留一切权利 <a href="https://beian.miit.gov.cn"
         target="_Blank">{{ ICP }}</a> </p>
  </div> -->
</template>
<script>
export default {
  name: '',
  components: {},
  props: {},
  data () {
    return {
      domainMap: {
        'www.utopa.com.cn': '粤ICP备16040467号',
        'www.myutopa.com': '粤ICP备17150681号',
        'www.myutopa.com.cn': '粤ICP备17150681号',
        'www.utopaparking.com': '粤ICP备17150681号',
        'utopaparking.com': '粤ICP备17150681号',
        'www.myutopa.net': '粤ICP备17150681号',
        'myutopa.net': '粤ICP备17150681号'
      },
      ICP: '粤ICP备17150681号'
    }
  },
  created () {
    // this.ICP = this.getICP() || '粤ICP备17150681号'
  },
  methods: {
    handleClick (item) {
      const url = 'https://mall-images.myutopa.com/images/'
      const images = item.map(i => url + i)
      window.open(`https://www.myutopa.com/m/mall/#/pages/store/licenseDetail/index?image=${encodeURIComponent(images)}`)
    },
    getCurDomain (url) {
      let domain
      // eslint-disable-next-line no-useless-escape
      const domainRegExp = /:\/\/([^\/]+)\//i
      try {
        domain = url.match(domainRegExp)[1]
      } catch (e) { }
      return domain
    },
    getICP () {
      window.open("https://beian.miit.gov.cn")
      const domain = this.getCurDomain(window.location.href)
      return this.domainMap[domain]
    }
  },
  computed: {}
}
</script>

<style scoped lang="scss">
.footer {
  width: 90%;
  // margin: 0 auto 15px;
  z-index: 2222 !important;
  position: absolute;
  bottom: 15px !important;
  left: 50% !important;
  transform: translateX(-50%);
  // background-color: #ffffff;
  .item {
    margin: 0 auto;
    text-align: center;
    padding: 0;
    margin: 0;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 17px;
    display: flex;
    flex-wrap: wrap;
    text-align: center;
    justify-content: center;
    z-index: 999999;
    div{
      cursor: pointer;
    }
    a {
      color: rgb(42, 123, 199);
      text-decoration: none;
      margin-left: 10px;
    }
  }
}
.page1 {
  margin-top: 80px;
}
.page3 {
  margin-top: 70px;
}
</style>
